<template>
    <div>
      <h4>Rating Scale Testing</h4>
      <p class="col-md-6 shadow mr-auto ml-auto" style="border-radius:1em;padding:1em;font-size:.9em;font-family:arial;">The idea is to create a single control that can display a range of quesiton responses to make it easy to drop a quick survey in the calling app.  The clicked value 
        should be what the control returns - if the desgner wants a number, they should choose the proper minVal and maxVal. The role of the control is to display the data
        that the rating user puts in the question data.   All these displays are created with the SAME control.
      </p>
        <RatingCard v-for="(r,index) in ratingData" :ratingData="r" :key="index" @selectedRating="selectedRating($event)" style="background:#e7f7f7;border-radius:2em;"></RatingCard>
        <!-- <RatingCard :ratingData="ratingData4" @selectedRating="selectedRating($event)"></RatingCard>
        <RatingCard :ratingData="ratingData1" @selectedRating="selectedRating($event)"></RatingCard>
        <RatingCard :ratingData="ratingData2" @selectedRating="selectedRating($event)"></RatingCard>
        <RatingCard :ratingData="ratingData3" @selectedRating="selectedRating($event)"></RatingCard> -->
    </div>    
</template>

<script>
// @ is an alias to /src
import RatingCard from '@/components/RatingCard.vue'

export default {
    name: 'Rating',
    components: {
        RatingCard
    },
    data () {
        return {
         ratingData: [ 
            {
                questionId: "101",
                question: "Simple 1-5 choice",
                iconType: "bubble-range",
                askText: false,
                textPrompt: "",
                showNA: false,
                sendPrompt: "",
                scale: {
                    minValue: 1,    
                    maxValue: 5,    // <-- the control stops at 5 -- should show this number
                    ratio: 1,
                    minText: "Less",
                    maxText: "More"
                }
            },
            {
                questionId: "201",
                question: "Text Replacement Qeustion, with minValue set to 1 so no = 1",
                iconType: "bubble-range",
                askText: false,
                textPrompt: "",
                showNA: false,
                sendPrompt: "",
                answers: ['Nope!','Maybe','Yep!'],
                buttonStyle: "border-radius:0;width:128px;height:64px;font-size:1.5em;font-weight:800;border-radius:.5em;",   // won't likey use this but it was fun to add.
                scale: {
                    minValue: 1,    
                    maxValue: 3,    // <-- the control stops at 5 -- should show this number
                    ratio: 1,
                    minText: "Less",
                    maxText: "More"
                }
            },
             {
                questionId: "102",
                question: "Choose a number between 5 and 9 ?",
                iconType: "bubble-range",
                askText: false,
                textPrompt: "",
                showNA: false,
                buttonStyle: "border-radius:0;height:64px;font-size:1.5em;font-weight:800;border-radius:.5em;",   // won't likey use this but it was fun to add.
                scale: {
                    minValue: 5,    
                    maxValue: 9,    // <-- the control stops at 5 -- should show this number
                    ratio: 1,
                    minText: "",
                    maxText: ""
                }
            },
            {
                questionId: "101",
                question: "Choose 300-400 step 10",
                iconType: "bubble-range",
                askText: true,
                textPrompt: "Ask me something",
                showNA: false,
                scale: {
                    minValue: 300,
                    maxValue: 400,      
                    ratio: 10,
                    minText: "None",
                    maxText: "Tons+"
                }
            },
            {
                questionId: "101",
                question: "Range 5001 - 5008 step 1",
                iconType: "bubble-range",
                askText: false,
                textPrompt: "",
                showNA: false,
                scale: {
                    minValue: 5001,        
                    maxValue: 5008,      
                    ratio: 1,
                    minText: "I did terrible",
                    maxText: "Aced It"
                }
            },
            {
                questionId: "110",
                question: "Smilies (max of 5 allowed)",
                iconType: "smiles",
                askText: false,
                textPrompt: "So, what do you think?",
                showNA: false,
                scale: {
                    minValue: 1,    // <-- I would have expected 4 faces, not 3
                    maxValue: 5,
                    maxText: "Visit us online"
                }
            },
             {
                questionId: "111",
                question: "Smilies (3 to 5)",
                iconType: "smiles",
                askText: false,
                textPrompt: "So, what do you think?",
                showNA: false,
                scale: {
                    minValue: 3,    // <-- I would have expected 4 faces, not 3
                    maxValue: 5,
                    maxText: "Visit us online"
                }
            },
             {
                questionId: "100",
                question: "Some blue offset 0-5, step 1",
                iconType: "bubble-range",
                askText: true,
                textPrompt: "How does the blue offset look? Weird, I think ...",
                showNA: false,
                sendPrompt: "Send us your rating",
                blueOffset: 255,
                scale: {
                    minValue: 0,    
                    maxValue: 5,    // <-- the control stops at 5 -- should show this number
                    ratio: 1,
                    minText: "Don't like dogs!!",
                    maxText: "More Than 5"
                }
            }
            // {
            //     questionId: "111",
            //     question: "Are you a scoccer fan?  <-- these faces are not right (should have 2)" ,
            //     iconType: "smiles",
            //     askText: false,
            //     textPrompt: "",
            //     showNA: false,
            //     scale: {
            //         minValue: 1,    // <-- the faces are not working correctly -- with just 2, I should have the min and max face
            //         maxValue: 2,
            //         minText: "no",
            //         maxText: "yes"
            //     }
            // },
            // {
            //     questionId: "120",
            //     question: "How do you like our blog? (Without icon type)",
            //     iconType:"sometihng-we-do-not-have-to-see-what-happens",
            //     askText: false,
            //     textPrompt: "",
            //     showNA: false,
            //     scale: {
            //         minValue: 10,
            //         maxValue: 20
            //     }
            // },
            // {
            //     questionId: "120",
            //     question: "What is the earliest car model year you owned",
            //     askText: true,
            //     textPrompt: "Please list cars you have owned (these questions don't need to make sense to us, it's the user that controls the content)",
            //     showNA: false,
            //     scale: {
            //         minText: "Pre-1980",
            //         maxText: "New Care Every Year",
            //         minValue: 1980,
            //         maxValue: 2020,
            //         ratio: 5
            //     }
            // }
         ] 
        }
    },
    methods: {
        selectedRating(rating) {
            console.log(rating);
            alert( "You selected \n" + JSON.stringify(rating ,null,2));
        }
    }
}
</script>
